import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { useLazyExportUsersQuery } from "../../../RTKQuery/CsvDataService/csvDataApi";

const ExportModal = ({ open, onClose, total, filters, sorting }) => {
  const [exportType, setExportType] = useState("all");
  const [batchSize, setBatchSize] = useState(1);
  const [userCount, setUserCount] = useState(0);

  const [exportUsers, { isLoading: exporting }] = useLazyExportUsersQuery();

  const handleExport = async () => {
    try {
      const batchCount = exportType === "batch" ? batchSize : 1;
      const userCountValue = exportType === "specific" ? userCount : total;
      await exportUsers({
        filters,
        sorting,
        batchCount,
        userCount: userCountValue,
        total,
      }).unwrap();
      handleClose();
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  const handleClose = () => {
    setExportType("all");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Export Users</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Choose an export option:
        </Typography>
        <RadioGroup
          value={exportType}
          onChange={(e) => setExportType(e.target.value)}
        >
          <FormControlLabel
            value="all"
            control={<Radio />}
            label={
              <p>
                Export All Users{" "}
                <span style={{ color: "#8ABA5C" }}>({total})</span>
              </p>
            }
          />
          <FormControlLabel
            value="batch"
            control={<Radio />}
            label="Export in Multiple CSVs"
          />
          {exportType === "batch" && (
            <TextField
              fullWidth
              margin="dense"
              label="Number of files"
              type="number"
              size="small"
              value={batchSize}
              onChange={(e) => setBatchSize(e.target.value)}
            />
          )}
          <FormControlLabel
            value="specific"
            control={<Radio />}
            label="Export Sorted Users"
            disabled={(sorting.length < 1 ? true : false)}
          />
          {exportType === "specific" && (
            <TextField
              fullWidth
              margin="dense"
              label="Number of Users"
              type="number"
              size="small"
              value={userCount}
              onChange={(e) => setUserCount(e.target.value)}
            />
          )}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          sx={{ color: "white" }}
          disabled={
            (exportType === "batch" && !batchSize) ||
            (exportType === "specific" && !userCount) ||
            exporting
          }
          onClick={handleExport}
        >
          {exporting ? "Exporting..." : "Export Users"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportModal;
